<mat-card class="card-style px-6 py-6 pt-0">
  <mat-card-header class="flex justify-between items-center">
    <mat-card-title class="">Importação tarifária</mat-card-title>
    <button class="btn-icon" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </mat-card-header>
  <div [formGroup]="form" class="mt-4">
    <div class="flex justify-between gap-4 items-center">
      <mat-form-field class="input-tg w-4/12" appearance="outline">
        <mat-label>Tipo tarifário</mat-label>
        <mat-select
          formControlName="tariffType"
          (selectionChange)="onSelectionChange($event)"
        >
          @for (type of listType; track type) {
            <mat-option [value]="type.id">{{ type.descricao }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      <mat-form-field class="input-tg w-8/12" appearance="outline">
        <mat-label>Cliente</mat-label>
        <input matInput formControlName="client" readonly />
        @if (this.form.get('client')!.enabled) {
          <button mat-icon-button matSuffix (click)="addClient()">
            <mat-icon>add</mat-icon>
          </button>
        }
      </mat-form-field>
    </div>
    <div class="flex justify-between gap-4 items-center">
      <mat-form-field class="input-tg w-full" appearance="outline">
        <mat-label>Fornecedor</mat-label>
        <input matInput formControlName="supplier" readonly />
          <button mat-icon-button matSuffix (click)="addSupplier()">
            <mat-icon>add</mat-icon>
          </button>
      </mat-form-field>
    </div>
    <div class="flex justify-between gap-8 items-center mt-3">
      <input
        hidden
        type="file"
        (change)="onFileSelected($event)"
        #fileInput
        [accept]="getAllowedTypes()"
      />
      <!--        accept=".xlsx,.application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"-->
      <mat-form-field
        class="input-tg input-btn-icon w-full"
        appearance="outline"
      >
        <mat-label>Arquivo</mat-label>
        <input matInput formControlName="file" readonly />
        <button mat-icon-button matSuffix (click)="fileInput.click()">
          <mat-icon>upload</mat-icon>
        </button>
      </mat-form-field>
    </div>
  </div>
  <div class="flex justify-end">
    <button
      mat-flat-button
      class="btn-tg w-1/5"
      [disabled]="!checkForm() || loading"
      (click)="importItem()"
    >
      @if (loading) {
        <mat-spinner diameter="22" class="loading-spinner"></mat-spinner>
      } @else {
        Importar
      }
    </button>
  </div>
</mat-card>
